var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "flex flex-col max-w-xl mx-auto my-10" }, [
      _c(
        "div",
        {
          staticClass:
            "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
        },
        [
          _c("div", { staticClass: "flex flex-col" }, [
            _c(
              "div",
              {
                staticClass:
                  "-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              },
              [
                _vm._m(0),
                _vm.isLoading ? _c("div", [_c("Spinner")], 1) : _vm._e(),
                _c(
                  "ul",
                  { staticClass: "space-y-3", attrs: { role: "list" } },
                  _vm._l(_vm.abandonedCartNotificationConfig.configs, function(
                    notificationConfig,
                    index
                  ) {
                    return _c(
                      "li",
                      {
                        key: index,
                        staticClass:
                          "overflow-hidden rounded-md bg-white px-6 py-4 shadow"
                      },
                      [
                        _c(
                          "h3",
                          {
                            staticClass:
                              "text-base font-semibold leading-6 text-gray-900"
                          },
                          [_vm._v(" Reminder " + _vm._s(index + 1) + " ")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "mt-2 max-w-xl text-sm text-gray-500"
                          },
                          [
                            _c("fieldset", [
                              _c(
                                "legend",
                                {
                                  staticClass:
                                    "text-base leading-6 font-medium text-gray-900"
                                },
                                [_vm._v(" Enable ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "mt-4 flex flex-wrap" },
                                [
                                  _c("VSwitch", {
                                    on: { input: _vm.updateNotificationConfig },
                                    model: {
                                      value: notificationConfig.isEnabled,
                                      callback: function($$v) {
                                        _vm.$set(
                                          notificationConfig,
                                          "isEnabled",
                                          $$v
                                        )
                                      },
                                      expression: "notificationConfig.isEnabled"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("div", [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "block text-sm font-medium leading-6 text-gray-900",
                                  attrs: { for: "location" }
                                },
                                [_vm._v("Timing")]
                              ),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: notificationConfig.timeout,
                                      expression: "notificationConfig.timeout"
                                    }
                                  ],
                                  staticClass:
                                    "mt-2 block w-full rounded-md py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 border p-3",
                                  on: {
                                    input: _vm.updateNotificationConfig,
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        notificationConfig,
                                        "timeout",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.abandonedCartTiming, function(
                                  option,
                                  index
                                ) {
                                  return _c(
                                    "option",
                                    {
                                      key: index,
                                      domProps: { value: option.value }
                                    },
                                    [_vm._v(_vm._s(option.label))]
                                  )
                                }),
                                0
                              ),
                              _c(
                                "p",
                                {
                                  staticClass:
                                    "mt-3 text-sm leading-6 text-gray-600"
                                },
                                [
                                  _vm._v(
                                    " Wait for " +
                                      _vm._s(
                                        _vm.getLabelForValue(
                                          notificationConfig.timeout,
                                          _vm.abandonedCartTiming
                                        )
                                      ) +
                                      " after cart is abandoned, then send "
                                  )
                                ]
                              )
                            ]),
                            _c("p")
                          ]
                        ),
                        _c("div", { staticClass: "mt-5" }, [
                          _c(
                            "button",
                            {
                              staticClass: "Polaris-Button",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.gotoConfigEditor(index)
                                }
                              }
                            },
                            [_vm._m(1, true)]
                          )
                        ])
                      ]
                    )
                  }),
                  0
                )
              ]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        {
          staticClass:
            "bg-gray-200 rounded-sm shadow-xs p-4 m-4 inline-flex mx-auto"
        },
        [_vm._v(" When a subscriber abandoned the cart ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [
        _vm._v("Edit Automation")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }